import React, {
  useState,
  useEffect,
  createContext,
  useContext,
  ReactChild,
} from 'react';
import usersApi from '../../services/users';
import { GetNewUserResponseSuccess } from '../../mocks/UserMocks';

interface UserProviderProps {
  userId: string;
  children: ReactChild | ReactChild[];
}

interface TargetUserContextType {
  userData: typeof GetNewUserResponseSuccess | Record<string, never>;
  isLoading: boolean;
  error: null | object;
}

// Create context
const UserContext = createContext<TargetUserContextType>({
  userData: {},
  isLoading: true,
  error: null,
});

// Export custom hook to use context
export const useGetTargetUserData = () => {
  return useContext(UserContext);
};

// Default provider
const UserProvider = ({ userId, children }: UserProviderProps) => {
  const [userData, setUserData] = useState({});
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getUserData = async () => {
      usersApi
        .getUser(userId)
        .then((response) => {
          setUserData(response.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setError(err);
          setIsLoading(false);
        });
    };

    getUserData();
  }, []);

  return (
    <UserContext.Provider value={{ userData, isLoading, error }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
